// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useState } from "react";

import { ThemeContext } from "./ThemeContext";

const themes = {
  "7f0c7a05-7944-4280-a260-3bffa8c329cf": "segurosUnimed", // prd
  "dd1127f2-b51b-4818-b0c8-25ea5ee579fb": "segurosUnimed", // dev
  default: "lively",
};

const specialThemes = {
  segurosUnimed: true,
  lively: false,
};

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes.default);
  const isSpecialTheme = specialThemes[theme];

  return (
    <ThemeContext.Provider value={{ theme, themes, setTheme, isSpecialTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeProvider };
